import dashboard from './dashboard';
import savedFilters from './savedFilters';

export default function* () {
    yield* [...dashboard, ...savedFilters];
}
